import { TableHistoryEntry } from './table-history.model';

export interface TableHistoryChange {
    column: string;
    before: string;
    after: string;
}

export function operationLabel(operation: string): string {
    switch (operation) {
        case 'insert': return 'Row added';
        case 'update': return 'Row updated';
        case 'revert_insert': return 'Insert reverted';
        case 'revert_update': return 'Update reverted';
        default: return operation;
    }
}

export function formatHistoryValue(value: unknown): string {
    if (value === null || value === undefined) return '';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
}

/** "id 5" or "id 5, region EU"; empty when the table has no primary key. */
export function formatRowId(rowId: Record<string, unknown> | null): string {
    if (!rowId) return '';
    return Object.entries(rowId)
        .map(([key, value]) => `${key} ${formatHistoryValue(value)}`)
        .join(', ');
}

/** Before and after for each column the entry touched, in the order it recorded them. */
export function changesOf(entry: TableHistoryEntry): TableHistoryChange[] {
    const columns = entry.columns?.length
        ? entry.columns
        : Object.keys({ ...(entry.oldValues ?? {}), ...(entry.newValues ?? {}) });
    return columns.map(column => ({
        column,
        before: formatHistoryValue(entry.oldValues?.[column]),
        after: formatHistoryValue(entry.newValues?.[column]),
    }));
}

/** A revert entry, or one that was already reverted, can no longer be reverted. */
export function revertBlockedReason(entry: TableHistoryEntry): string | null {
    if (entry.operation.startsWith('revert_')) return null;
    if (entry.revertedById) return 'Reverted';
    return null;
}
